export default __webpack_public_path__ + "static/media/20-Serenity.90b2b3ef.jpeg";